<template>
  <div class="score-card-wrap">
    <div class="score-card">
      <img class="medal" src="@/assets/img/medal.png">
      <div class="title">恭喜你完成本次课程学习</div>
      <div class="score"><span class="score-num">{{score}}</span>分</div>
      <div class="text">{{content}}</div>
      <div class="complete-btn" @click="onComplete">完成</div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      score: 0,
      content: '',
    }
  },
  methods: {
    getScore () {
      this.$store.dispatch('course/getScore', { pkid: this.$route.params.videoId }).then(res => {
        this.score = res.score
        this.content = res.content
      })
    },
    onComplete () {
      this.$emit('hideScore')
    },
  },
  mounted () {
    this.getScore()
  },
}
</script>
<style lang="scss" scoped>
.score-card-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 11
}
.score-card {
  position: relative;
  background: #fff;
  border-radius: 12px;
  width: 300px;
  height: 330px;
  margin: 0 auto;
  margin: 0 37px;
  .medal {
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translate(-50%, 0);
  }
  .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #212121;
    text-align: center;
    margin-top: 60px;
    background-image: url('~@/assets/img/score-bgimg.png');
    background-repeat:  no-repeat;
    background-position: center;
  }
  .score {
    margin-top: 12px;
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    color: #979797;
    text-align: center;
    .score-num {
      font-family: DIN;
      font-size: 50px;
      line-height: 59px;
      font-weight: normal;
      color: #ED6C00;
    }
  }
  .text {
    display: flex;
    width: 80%;
    height: 70px;
    margin: 20px auto;
    background: rgba(252, 236, 218, 0.44);
    border-radius: 2px;
    font-size: 12px;
    justify-content: center;
    align-items: center;
    line-height: 17px;
    color: #666666;
    padding: 0 36px;
    text-align: center;
  }
  .complete-btn {
    position: absolute;
    width: 160px;
    height: 40px;
    left: 50%;
    transform: translate(-50%);
    background: #ED6C00;
    border-radius: 48px;
    color: #fff;
    line-height: 40px;
    text-align: center;
  }
}
</style>
